// src/pages/EditUserPage.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Box, Typography, TextField, Button, Paper, Alert, 
  CircularProgress, FormControl, InputLabel, Select, MenuItem 
} from '@mui/material';

function EditUserPage() {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [user, setUser] = useState({ name: '', email: '', password: '', role: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`https://luiatro-health-cloud-production.up.railway.app/api/users/${id}`);
        if (!response.ok) throw new Error('Usuario no encontrado');
        const data = await response.json();
        
        // Normalización de roles antiguos al cargar datos
        if (data.role === 'usuario') data.role = 'medico';
        
        setUser({ ...data, password: '' }); // Cargamos datos y reseteamos campo password por seguridad
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`https://luiatro-health-cloud-production.up.railway.app/api/users/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al actualizar el usuario');
      }

      setSuccess('¡Usuario actualizado con éxito!');
      setTimeout(() => navigate('/users'), 1500);

    } catch (err) {
      setError(err.message);
    }
  };

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 500, mx: 'auto', mt: 4, p: 3 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Editar Usuario
        </Typography>
        
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        
        <TextField
          fullWidth
          label="Nombre Completo"
          name="name"
          value={user.name}
          onChange={handleChange}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Correo Electrónico"
          name="email"
          type="email"
          value={user.email}
          onChange={handleChange}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Nueva Contraseña"
          name="password"
          type="password"
          value={user.password}
          onChange={handleChange}
          margin="normal"
          helperText="Dejar en blanco para mantener la contraseña actual"
        />
        
        <FormControl fullWidth margin="normal" required>
          <InputLabel id="role-select-label">Rol del Sistema</InputLabel>
          <Select
            labelId="role-select-label"
            name="role"
            value={user.role}
            label="Rol del Sistema"
            onChange={handleChange}
          >
            {/* ROLES ACTUALIZADOS Y SINCRONIZADOS */}
            <MenuItem value="administrador">Administrador</MenuItem>
            <MenuItem value="medico">Médico Tratante</MenuItem>
            <MenuItem value="asistente">Asistente Administrativo</MenuItem>
          </Select>
        </FormControl>
        
        <Button 
          type="submit" 
          variant="contained" 
          color="primary" 
          fullWidth 
          sx={{ mt: 3, py: 1.5 }}
          size="large"
        >
          Actualizar Datos
        </Button>
        
        <Button 
          fullWidth 
          variant="text" 
          onClick={() => navigate('/users')} 
          sx={{ mt: 1 }}
        >
          Cancelar y Volver
        </Button>
      </Paper>
    </Box>
  );
}

export default EditUserPage;